import { Injectable, inject } from '@angular/core';
import { FilterQueryBuilder } from '../models/filter-query-builder';
import { ColumnFilterState } from '../models/column-filter-state';
import { SessionStorageService } from '@core/session-storage.service';

@Injectable()
export class FilterSessionManagerService {
  private readonly session = inject(SessionStorageService);

  private filterSession?: FilterQueryBuilder;
  private sessionKey!: string;

  initialize(filterSession: FilterQueryBuilder, sessionKey: string): void {
    this.filterSession = filterSession;
    this.sessionKey = sessionKey;
  }

  hasSession(): boolean {
    return this.sessionKey !== undefined && this.filterSession !== undefined;
  }

  updateSkip(skip: number): void {
    this.filterSession!.updateSkip(skip);
    this.update(this.filterSession!.toSessionString());
  }

  updateTop(top: number): void {
    this.filterSession!.updateTop(top);
    this.update(this.filterSession!.toSessionString());
  }

  updateFilter<T>(column: ColumnFilterState<T>): void {
    this.filterSession!.updateFilter(column.columnName, column.getValue());
    this.update(this.filterSession!.toSessionString());
  }

  removeFilter<T>(column: ColumnFilterState<T>): void {
    this.filterSession!.removeFilter(column.columnName);
    this.update(this.filterSession!.toSessionString());
  }

  clearFilters(): void {
    this.filterSession!.clearFilter();
  }

  hasValueFor(key: string): boolean {
    return !!(this.filterSession && this.filterSession!.getValue(key));
  }

  getValue<T>(key: string): T {
    return this.filterSession!.getValue(key) as T;
  }

  destroy(): void {
    this.filterSession = undefined;
  }

  private update(session: string): void {
    this.session.set(this.sessionKey!, session);
  }
}
